@if (selectedDurationText()) {
  {{ selectedDurationText() }}
} @else {
  <div class="stencil-shimmer"></div>
}
